import React, { useState, useEffect, useRef } from "react";
import {
  Calendar,
  Plus,
  Trash2,
  Edit,
} from "lucide-react";
import { CarryOutOutlined, FileTextOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import {
  Button,
  Card,
  Table,
  Input,
  Select,
  DatePicker,
  TimePicker,
  Modal,
  Checkbox,
  Typography,
  Tag,
  Row,
  Col,
  Divider,
  Space,
  Form,
  InputNumber,
  ColorPicker,
  Upload,
  message,
  Radio,
  Tooltip,
  List,
  Progress
} from "antd";
import moment from 'moment';
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeftOutlined, ArrowRightOutlined, BuildOutlined, CheckOutlined, CopyOutlined, DeleteOutlined, DesktopOutlined, EditOutlined, EnvironmentOutlined, FileSearchOutlined, GiftOutlined, HighlightOutlined, InboxOutlined, MinusCircleOutlined, MobileOutlined, PlusOutlined, SearchOutlined, TabletOutlined, UploadOutlined } from "@ant-design/icons";
import LeafletPicker from "./LeafletPicker.js"
import GoogleMapPicker from "./LeafletPicker.js";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import InviteeRegistrationForm from "./dynamicform.js";
import {
  EyeOutlined,
  SaveOutlined,
  CloseOutlined,
  MailOutlined,
  PhoneOutlined,
  CalendarOutlined,
  TeamOutlined,
  TagOutlined,
  HomeOutlined,
  ApartmentOutlined,
  FileOutlined,
  StarOutlined,
  NumberOutlined,
  UserOutlined,
  FontSizeOutlined,
  FormOutlined,
  DotChartOutlined,
  DollarOutlined,
  CalculatorOutlined,
  DatabaseOutlined,
  CheckSquareOutlined,
  AppstoreOutlined,
  TableOutlined,
  ClockCircleOutlined,
  PictureOutlined,
  AudioOutlined,
  VideoCameraOutlined,
  InfoCircleOutlined,
  CodeOutlined,
  IdcardOutlined,
  FileProtectOutlined,
  MinusSquareOutlined,
  CreditCardOutlined,
} from "@ant-design/icons";
import LocationPicker from "./LeafletPicker.js";
import TicketManagementUI from "../TicketManage/Manage.js";
import BadgeTemplatesGallery from "../TicketManage/BadgeTemplatesGallery.js";
import { uploadData, getUrl } from '@aws-amplify/storage';
import ThemeCustomizer from "../../ThemeCustomizer/ThemeCustomizer.js";

const { Option } = Select;
const { TextArea } = Input;
const { RangePicker } = DatePicker;
const { Title, Text } = Typography;

export default function EventRegistrationUI() {
  const [activeTab, setActiveTab] = useState("define-event");
  const [eventData, setEventData] = useState(null);
  //console.log("Event Data:", eventData)
  const [eventPoster, setEventPoster] = useState([]);
  // console.log("Event Poster:", eventPoster);
  const [programPoster, setProgramPoster] = useState([]);
  const [termsFile, setTermsFile] = useState([]);
  const [draftEventId, setDraftEvent] = useState(null);
  // console.log("Draft Ev   ent ID:", draftEventId);
  const initialMainRows = [
    { key: "visitor", name: "Visitor / Audience" },
    { key: "participant", name: "Participant / Performer" },
    { key: "sponsor", name: "Sponsor" },
    { key: "exhibitor", name: "Exhibitor" },
    { key: "vendor", name: "Vendor" },
  ];

  const [mainRows] = useState(initialMainRows);
  const [details, setDetails] = useState({});
  const [previewMode, setPreviewMode] = useState("desktop");
  const [visitorCategories, setVisitorCategories] = useState([
    { id: 1, label: "VIP", seats: null, discount: null, color: "#1890ff" },
  ]);

  const [sponsors, setSponsors] = useState([]);
  const [previewImage, setPreviewImage] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [programs, setPrograms] = useState([]);
  // console.log("Programs:", programs);
  const [openAdvanced, setOpenAdvanced] = useState(false);
  const [editingRowKey, setEditingRowKey] = useState(null);
  const [programModalVisible, setProgramModalVisible] = useState(false);
  const [editingProgram, setEditingProgram] = useState(null);
  const [typeForm] = Form.useForm();
  const [roleForm] = Form.useForm(); // for role modal

  const [roles, setRoles] = useState([]);
  const [isRoleModalOpen, setIsRoleModalOpen] = useState(false);
  const [isTypeModalOpen, setIsTypeModalOpen] = useState(false);
  const [currentRoleId, setCurrentRoleId] = useState(null);
  console.log("Current Role ID:", currentRoleId);
  const roleEditingRef = useRef(null);
  const [isFieldModalOpen, setIsFieldModalOpen] = useState(false);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [currentInviteeId, setCurrentInviteeId] = useState(null);
  const [editingField, setEditingField] = useState(null);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const [uploading, setUploading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [termsUploading, setTermsUploading] = useState(false);
  const [posterUploading, setPosterUploading] = useState(false);
  const [isInviteeModalOpen, setIsInviteeModalOpen] = useState(false);
  const [customForms, setCustomForms] = useState({});
  const [posterUrl, setPosterUrl] = useState(null);
  // console.log("Poster URL:", posterUrl);
  const [ticketData, setTicketData] = useState([]);
  //console.log("Ticket Data:", ticketData);
  const programFormDataDefault = {
    title: "",
    description: "",
    date: "",
    startTime: "",
    endTime: "",
    speaker: "",
    venue: "",
    category: "sport",
    maxAttendees: "",
  };
  const [programFormData, setProgramFormData] = useState(programFormDataDefault);

  // Fetch draft/event details by id and populate form + state
  const fetchEventDetails = async (eventId) => {
    if (!eventId) return;
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/admin/event/get-draft/${eventId}`
      );
      const data = await res.json();

      const eventData = data?.info || data?.data;
      setEventData(eventData);

      if (eventData) {
        form.setFieldsValue({
          ...eventData,
          startDate: eventData.startDate ? moment(eventData.startDate) : null,
          endDate: eventData.endDate ? moment(eventData.endDate) : null,
          registrationStart: eventData.registrationStart ? moment(eventData.registrationStart) : null,
          registrationEnd: eventData.registrationEnd ? moment(eventData.registrationEnd) : null,
        });

        if (eventData.programs) setPrograms(eventData.programs);
        if (eventData.inviteeRoles) {
          // normalize backend _id to id so UI logic is consistent
          const normalizedRoles = eventData.inviteeRoles.map(r => ({ ...r, id: r.id || r._id }));
          setRoles(normalizedRoles);
        }
        if (eventData.ticketClasses) setTicketData(eventData.ticketClasses);
        if (eventData.venues) setVenues(eventData.venues);

        // set draft id so other logic that relies on draftEventId works
        setDraftEvent(eventId);
      }
    } catch (error) {
      console.error("Error fetching event details:", error);
    }
  };

  // Read incoming event id from navigation state or query param
  const location = useLocation();
  const navEventId =
    location?.state?.eventId ||
    new URLSearchParams(window.location.search).get("id") ||
    null;

  useEffect(() => {
    if (navEventId) {
      fetchEventDetails(navEventId);
    }
  }, [navEventId]);


  // //console.log("Custom Forms State:", customForms);
  const [currentForm, setCurrentForm] = useState({
    title: 'Registration Form',
    description: '',
    fields: []
  });
  // Simple toast message
  const showMessage = (msg, type = 'success') => {
    setMessage(msg);
    setTimeout(() => setMessage(''), 3000);
  };
  const capitalize = (str) =>
    str
      .split(" ")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");

  // 🟦 Move to next tab (sequence controlled)
  const handleNextTab = () => {
    const order = [
      "define-event",
      "event-program-calendar",
      "event-terms",
      "event-invitees",
    ];

    const currentIndex = order.indexOf(activeTab);
    if (currentIndex < order.length - 1) {
      setActiveTab(order[currentIndex + 1]);
    }
  };
  // Create a new field object
  const createNewField = (fieldType) => {
    const fieldTypeConfig = fieldTypes.find(f => f.value === fieldType) || { label: fieldType };
    return {
      id: `${Date.now()}-${Math.floor(Math.random() * 10000)}`,
      type: fieldType,
      label: `${fieldTypeConfig.label}`,
      placeholder: `Enter ${String(fieldTypeConfig.label).toLowerCase()}`,
      required: false,
      description: '',
      options: ['select', 'radio', 'checkbox'].includes(fieldType) ? ['Option 1', 'Option 2'] : undefined
    };
  };

  const onDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return; // dropped outside

    // Dragging from palette to form -> add a NEW field
    if (source.droppableId === 'palette' && destination.droppableId === 'form') {
      const fieldType = fieldTypes[source.index].value;
      const newField = createNewField(fieldType);
      const newFields = Array.from(currentForm.fields);
      newFields.splice(destination.index, 0, newField);
      setCurrentForm({ ...currentForm, fields: newFields });
      showMessage('Field added! Click to edit properties.');
      return;
    }

    // Reordering within form
    if (source.droppableId === 'form' && destination.droppableId === 'form') {
      const newFields = Array.from(currentForm.fields);
      const [moved] = newFields.splice(source.index, 1);
      newFields.splice(destination.index, 0, moved);
      setCurrentForm({ ...currentForm, fields: newFields });
      showMessage('Field reordered!');
      return;
    }

  };

  const handleDuplicateField = (fieldId) => {
    const fieldToDuplicate = currentForm.fields.find(f => f.id === fieldId);
    if (!fieldToDuplicate) return;
    const duplicatedField = {
      ...fieldToDuplicate,
      id: `${Date.now()}-${Math.floor(Math.random() * 10000)}`,
    };
    const index = currentForm.fields.findIndex(f => f.id === fieldId);
    const newFields = [...currentForm.fields];
    newFields.splice(index + 1, 0, duplicatedField);
    setCurrentForm({ ...currentForm, fields: newFields });
    showMessage('Field duplicated!');
  };

  const FieldPalette = () => {
    const [searchTerm, setSearchTerm] = useState("");

    // Filtered field list
    const filteredFields = fieldTypes.filter((field) =>
      field.label.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
      <Card
        title="Add Fields"
        size="small"
        className="h-full"
        bodyStyle={{ padding: "12px" }}
        style={{ height: "500px", display: "flex", flexDirection: "column" }} // fixed height
      >
        {/* Search Bar */}
        <Input
          prefix={<SearchOutlined />}
          placeholder="Search fields..."
          allowClear
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ marginBottom: "12px" }}
        />

        {/* Subtitle */}
        <div
          className="p-3 bg-gray-50 rounded text-center mb-4"
          style={{
            fontSize: "14px",
            color: "#6b7280",
            marginBottom: "12px",
            flexShrink: 0,
          }}
        >
          Drag fields to the form area to add them
        </div>

        {/* Scrollable Field List */}

        <Droppable droppableId="palette" isDropDisabled={true}>
          {(provided) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "12px",
              }}
            >
              {filteredFields.length > 0 ? (
                filteredFields.map((fieldType, index) => (
                  <Draggable
                    key={fieldType.value}
                    draggableId={`palette-${fieldType.value}`}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className={`flex items-center border rounded cursor-move transition-all duration-200 ${snapshot.isDragging
                          ? "bg-blue-50 border-blue-400 shadow-md"
                          : "bg-white border-gray-200 hover:border-blue-300 hover:shadow-sm"
                          }`}
                        style={{ ...provided.draggableProps.style }}
                      >
                        <div
                          className="flex items-center justify-center w-10 h-10 bg-gray-100 border-r rounded-l p-4"
                          style={{
                            backgroundColor: snapshot.isDragging ? "#dbeafe" : "#f9fafb",
                            transition: "background-color 0.2s ease",
                            padding: "5px",
                          }}
                        >
                          <span style={{ fontSize: "16px" }}>{fieldType.icon}</span>
                          <span className="flex-1 px-3 py-2  p-3 ml-4">{fieldType.label}</span>
                        </div>
                        {/* <span className="flex-1 px-3 py-2">
                          {fieldType.label}
                        </span> */}
                      </div>
                    )}
                  </Draggable>
                ))
              ) : (
                <p
                  style={{
                    gridColumn: "span 2",
                    textAlign: "center",
                    color: "#999",
                  }}
                >
                  No fields found
                </p>
              )}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </Card>
    );
  };
  const FieldForm = ({ field, onSave, onCancel }) => {
    const [form] = Form.useForm();

    // When the field prop changes, set form fields accordingly.
    useEffect(() => {
      if (field) {
        form.setFieldsValue(field);
      } else {
        form.resetFields();
      }
    }, [field, form]);

    // Use onFinish to handle saving
    const handleFinish = (values) => {
      const finalField = {
        ...field,
        ...values,
        id: field?.id || `${Date.now()}-${Math.floor(Math.random() * 10000)}`,
      };
      onSave(finalField);
    };

    // Determine if the field needs options
    const needsOptions = ['select', 'radio', 'checkbox'].includes(field?.type || 'text');

    return (
      <Form layout="vertical" form={form} onFinish={handleFinish}>
        <Form.Item
          name="label"
          label="Field Label"
          rules={[{ required: true, message: 'Please enter the field label' }]}
        >
          <Input placeholder="Enter field label" />
        </Form.Item>

        <Form.Item name="type" label="Field Type">
          <Select>
            {fieldTypes.map(type => (
              <Select.Option key={type.value} value={type.value}>
                {type.icon} {type.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="placeholder" label="Placeholder Text">
          <Input placeholder="Enter placeholder text" />
        </Form.Item>

        <Form.Item name="required" valuePropName="checked" label="Required Field">
          <Checkbox>Mark as required</Checkbox>
        </Form.Item>

        {needsOptions && (
          <Form.List name="options" initialValue={field?.options || ['']}>
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }, index) => (
                  <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                    <Form.Item
                      {...restField}
                      name={[name]}
                      rules={[{ required: true, message: 'Please input an option' }]}
                    >
                      <Input placeholder={`Option ${index + 1}`} />
                    </Form.Item>
                    {fields.length > 1 && (
                      <MinusCircleOutlined onClick={() => remove(name)} style={{ color: 'red' }} />
                    )}
                  </Space>
                ))}
                <Form.Item>
                  <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                    Add Option
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        )}

        <Form.Item name="description" label="Help Text">
          <Input.TextArea rows={3} placeholder="Additional instructions for this field" />
        </Form.Item>

        <Form.Item>
          <Space>
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              {field ? 'Update Field' : 'Add Field'}
            </Button>
          </Space>
        </Form.Item>
      </Form>
    );
  };
  // Preview component (unchanged)
  const FormPreview = ({ form }) => {
    const [formData, setFormData] = useState({});

    const handleFieldChange = (fieldId, value) => {
      setFormData({ ...formData, [fieldId]: value });
    };

    const renderField = (field) => {
      const baseProps = {
        placeholder: field.placeholder,
        value: formData[field.id] || '',
        onChange: (e) => handleFieldChange(field.id, e.target.value)
      };

      switch (field.type) {
        case 'text':
        case 'email':
        case 'phone':
          return <Input {...baseProps} type={field.type} />;

        case 'textarea':
          return <TextArea {...baseProps} rows={3} />;

        case 'select':
          return (
            <Select {...baseProps} placeholder={field.placeholder}>
              <Option value="">Select an option</Option>
              {field.options?.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          );

        case 'radio':
          return (
            <Radio.Group {...baseProps}>
              <Space direction="vertical">
                {field.options?.map(option => (
                  <Radio key={option} value={option}>{option}</Radio>
                ))}
              </Space>
            </Radio.Group>
          );

        case 'checkbox':
          return (
            <Checkbox.Group {...baseProps}>
              <Space direction="vertical">
                {field.options?.map(option => (
                  <Checkbox key={option} value={option}>{option}</Checkbox>
                ))}
              </Space>
            </Checkbox.Group>
          );

        case 'number':
          return <InputNumber {...baseProps} style={{ width: '100%' }} />;

        case 'date':
          return <DatePicker {...baseProps} style={{ width: '100%' }} />;

        case 'file':
          return (
            <Upload>
              <Button icon={<UploadOutlined />}>Upload File</Button>
            </Upload>
          );

        case 'rating':
          return (
            <div className="flex space-x-1">
              {[1, 2, 3, 4, 5].map(star => (
                <Button
                  key={star}
                  type="text"
                  className={`text-2xl ${(formData[field.id] || 0) >= star ? 'text-yellow-400' : 'text-gray-300'}`}
                  onClick={() => handleFieldChange(field.id, star)}
                >
                  ⭐
                </Button>
              ))}
            </div>
          );

        default:
          return <Input {...baseProps} />;
      }
    };

    return (
      <Card
        title={form.title}
        className="h-full"
        bodyStyle={{ maxHeight: '400px', overflow: 'auto' }}
      >
        {form.description && (
          <Text type="secondary" className="mb-4 block">
            {form.description}
          </Text>
        )}

        <Form layout="vertical">
          {form.fields.map(field => (
            <Form.Item
              key={field.id}
              label={
                <span>
                  {field.label}
                  {field.required && <Text type="danger"> *</Text>}
                </span>
              }
              help={field.description && <Text type="secondary">{field.description}</Text>}
            >
              {renderField(field)}
            </Form.Item>
          ))}

          {form.fields.length === 0 && (
            <div className="text-center py-8">
              <Text type="secondary">
                No fields added yet. Drag fields from the palette to start building your form.
              </Text>
            </div>
          )}

          {form.fields.length > 0 && (
            <div className="flex justify-center mt-4">
              <Button type="primary" size="middle">
                Submit
              </Button>
            </div>


          )}
        </Form>
      </Card>
    );
  };

  // Event handlers
  const handleSaveField = (fieldData) => {
    const newFields = editingField
      ? currentForm.fields.map(f => (f.id === editingField.id ? fieldData : f))
      : [...currentForm.fields, fieldData];

    setCurrentForm({ ...currentForm, fields: newFields });
    setIsFieldModalOpen(false);
    setEditingField(null);
    showMessage(editingField ? 'Field updated!' : 'Field added!');
  };

  const handleDeleteField = (fieldId) => {
    setCurrentForm({
      ...currentForm,
      fields: currentForm.fields.filter(f => f.id !== fieldId)
    });
    showMessage('Field deleted!');
  };

  const handleSaveForm = async () => {
    if (!currentForm.title.trim()) {
      showMessage("Please enter a form title", "error");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/admin/dynamicform/saveforms`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            inviteeId: currentInviteeId,
            ...currentForm,
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        // //console.log("✅ Form saved successfully:", data);
        showMessage("Form saved successfully!");

        setCustomForms((prev) => ({
          ...prev,
          [currentInviteeId]: { ...currentForm },
        }));

        setCurrentForm({
          title: "Registration Form",
          description: "",
          fields: [],
        });
        setCurrentInviteeId(null);
        setIsInviteeModalOpen(false);
      } else {
        //console.error("❌ Error saving form:", data);
        showMessage("Error saving form", "error");
      }
    } catch (error) {
      //console.error("❌ Error saving form:", error);
      showMessage("Error saving form", "error");
    }
  };

  const resetForm = () => {
    setCurrentForm({
      title: 'Registration Form',
      description: '',
      fields: []
    });
    setCurrentInviteeId(null);
  };

  const handleCloseModal = () => {
    setIsInviteeModalOpen(false);
    resetForm();
  };

  const fieldTypes = [
    // Basic Info
    { value: "text", label: "Name", icon: <UserOutlined /> },
    { value: "email", label: "Email address", icon: <MailOutlined /> },
    { value: "phone", label: "Phone number", icon: <PhoneOutlined /> },
    { value: "date", label: "Date of birth", icon: <CalendarOutlined /> },
    { value: "company", label: "Company", icon: <ApartmentOutlined /> },
    { value: "job", label: "Job title", icon: <HomeOutlined /> },
    { value: "referral", label: "Referral", icon: <TeamOutlined /> },
    { value: "meals", label: "Meals", icon: <TagOutlined /> },
    { value: "website", label: "Website", icon: <FileOutlined /> },

    // Textbox
    { value: "singleline", label: "Single Line", icon: <FontSizeOutlined /> },
    { value: "multiline", label: "Multi Line", icon: <FormOutlined /> },

    // Number
    { value: "number", label: "Number", icon: <NumberOutlined /> },
    { value: "decimal", label: "Decimal", icon: <DotChartOutlined /> },
    { value: "currency", label: "Currency", icon: <DollarOutlined /> },
    { value: "formula", label: "Formula", icon: <CalculatorOutlined /> },

    // Choices
    { value: "dropdown", label: "Dropdown", icon: <DatabaseOutlined /> },
    { value: "radio", label: "Radio", icon: <CheckSquareOutlined /> },
    { value: "checkbox", label: "Checkbox", icon: <AppstoreOutlined /> },
    { value: "multipleChoice", label: "Multiple Choice", icon: <AppstoreOutlined /> },
    { value: "imageChoice", label: "Image Choices", icon: <PictureOutlined /> },

    // Matrix Choices
    { value: "matrixRadio", label: "Matrix Radio", icon: <TableOutlined /> },
    { value: "matrixCheckbox", label: "Matrix Checkbox", icon: <TableOutlined /> },
    { value: "matrixDropdown", label: "Matrix Dropdown", icon: <TableOutlined /> },
    { value: "matrixTextbox", label: "Matrix Textbox", icon: <TableOutlined /> },
    { value: "matrixNumber", label: "Matrix Number", icon: <TableOutlined /> },
    { value: "matrixCurrency", label: "Matrix Currency", icon: <TableOutlined /> },

    // Date & Time
    { value: "date", label: "Date", icon: <CalendarOutlined /> },
    { value: "time", label: "Time", icon: <ClockCircleOutlined /> },
    { value: "datetime", label: "Date-Time", icon: <CalendarOutlined /> },
    { value: "monthyear", label: "Month-Year", icon: <CalendarOutlined /> },

    // Uploads
    { value: "file", label: "File Upload", icon: <UploadOutlined /> },
    { value: "imageUpload", label: "Image Upload", icon: <PictureOutlined /> },
    { value: "avUpload", label: "Audio/Video Upload", icon: <VideoCameraOutlined /> },

    // Rating Scales
    { value: "rating", label: "Rating", icon: <StarOutlined /> },
    { value: "slider", label: "Slider", icon: <DotChartOutlined /> },

    // Instructions
    { value: "description", label: "Description", icon: <InfoCircleOutlined /> },
    { value: "embed", label: "Audio/Video Embed", icon: <CodeOutlined /> },

    // Identifier
    { value: "uniqueId", label: "Unique ID", icon: <IdcardOutlined /> },
    { value: "randomId", label: "Random ID", icon: <IdcardOutlined /> },

    // Legal & Consent
    { value: "terms", label: "Terms & Conditions", icon: <FileProtectOutlined /> },
    { value: "signature", label: "Signature", icon: <EditOutlined /> },
    { value: "decisionBox", label: "Decision Box", icon: <CheckSquareOutlined /> },

    // Page Elements
    { value: "section", label: "Section", icon: <MinusSquareOutlined /> },
    { value: "pageBreak", label: "Page Break", icon: <MinusSquareOutlined /> },

    // Advanced
    { value: "payment", label: "Payment", icon: <CreditCardOutlined /> },
  ];

  const [form] = Form.useForm();
  //console.log("form", form);
  // const [venues, setVenues] = useState([{ key: Date.now() }]);
  const [venues, setVenues] = useState([
    { key: Date.now(), venueName: "", city: "", state: "" }
  ]);


  const handleVenueChange = (index, field, value) => {
    const updatedVenues = [...venues];
    updatedVenues[index][field] = value;
    setVenues(updatedVenues);
  };

  const addVenue = () => {
    setVenues([...venues, { key: Date.now() }]);
  };

  const removeVenue = (key) => {
    setVenues(venues.filter((v) => v.key !== key));
  };

  // When draftEventId is set elsewhere (e.g., after saving), reuse the same fetchEventDetails
  useEffect(() => {
    if (draftEventId) {
      fetchEventDetails(draftEventId);
    }
  }, [draftEventId]);


  const editProgram = (program) => {
    setEditingProgram(program);
    setProgramFormData(program);
    setProgramModalVisible(true);
  };


  const handleSaveProgram = () => {
    //console.log("Program Form Data:", programFormData);
    if (
      !programFormData.title ||
      !programFormData.category ||
      !programFormData.date ||
      !programFormData.startTime ||
      !programFormData.endTime
    ) {
      alert("Please fill required fields: Title, Category, Date, Start Time and End Time");
      return;
    }

    if (editingProgram) {
      // Update existing program
      setPrograms((prev) =>
        prev.map((p) =>
          p.id === editingProgram.id ? { ...editingProgram, ...programFormData } : p
        )
      );
    } else {
      // Add new program
      setPrograms((prev) => [
        ...prev,
        { id: Date.now(), ...programFormData },
      ]);
    }

    // Reset form and close modal
    setProgramFormData(programFormDataDefault);
    setEditingProgram(null);
    setProgramModalVisible(false);
  };

  const deleteProgram = (id) => {
    Modal.confirm({
      title: "Are you sure you want to delete this program?",
      onOk() {
        setPrograms(programs.filter(p => p.id !== id));
        alert("Program deleted successfully");
      },
    });
  };

  // ...existing code...
  const handleEditRole = (role) => {
    console.log("Editing role:", role);
    const id = role.id || role._id; // accept either id or _id
    roleEditingRef.current = id;
    console.log("roleEditingRef.current set to:", roleEditingRef.current);
    setCurrentRoleId(id);
    roleForm.setFieldsValue({
      roleName: role.roleName,
      totalSeats: role.totalSeats,
      perPersonLimit: role.perPersonLimit,
      registrationStart: role.registrationStart ? moment(role.registrationStart) : null,
      registrationEnd: role.registrationEnd ? moment(role.registrationEnd) : null,
      payment: role.payment,
    });
    setIsRoleModalOpen(true);
  };
  // ...existing code...

  // Delete role function
  const handleDeleteRole = (roleId) => {
    console.log("Deleting role with ID:", roleId);

    Modal.confirm({
      title: "Are you sure you want to delete this role?",
      content: "This action cannot be undone and will also delete all associated types.",
      okText: "Yes, Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        setRoles(prev => prev.filter(role => role._id !== roleId)); // Changed role.id to role._id
        // Also remove any custom form associated with this role
        setCustomForms(prev => {
          const newForms = { ...prev };
          delete newForms[roleId];
          return newForms;
        });
        showMessage("Role deleted successfully");
      },
    });
  };


  const handleAddRole = (values) => {
    // prefer the ref set during edit (stable across rerenders), fallback to state
    const editingId = roleEditingRef.current || currentRoleId;

    if (editingId) {
      // Editing existing role
      const updatedRoles = roles.map((role) => {
        if (role.id === editingId || role._id === editingId) { // check both id and _id
          return {
            // ensure id stays present for consistent future operations
            ...role,
            id: role.id || role._id || editingId,
            roleName: values.roleName,
            totalSeats: values.totalSeats,
            perPersonLimit: values.perPersonLimit,
            registrationStart: values.registrationStart
              ? values.registrationStart.format("YYYY-MM-DD HH:mm")
              : null,
            registrationEnd: values.registrationEnd
              ? values.registrationEnd.format("YYYY-MM-DD HH:mm")
              : null,
            payment: values.payment,
          };
        }
        return role;
      });
      setRoles(updatedRoles);
      showMessage("Role updated successfully");
    } else {
      // Adding new role
      const newId = Date.now().toString();
      const newRole = {
        id: newId,
        roleName: values.roleName,
        totalSeats: values.totalSeats,
        perPersonLimit: values.perPersonLimit,
        registrationStart: values.registrationStart
          ? values.registrationStart.format("YYYY-MM-DD HH:mm")
          : null,
        registrationEnd: values.registrationEnd
          ? values.registrationEnd.format("YYYY-MM-DD HH:mm")
          : null,
        payment: values.payment,
        types: [],
      };
      setRoles((prev) => [...prev, newRole]);
      showMessage("Role added successfully");
    }

    roleForm.resetFields();
    setIsRoleModalOpen(false);
    setCurrentRoleId(null);
    roleEditingRef.current = null;
  };

  const handleAddType = (values) => {
    const typeData = {
      id: editingType ? editingType.id : Date.now(),
      ...values,
      registrationWindow: [
        values.registrationWindow[0].format("YYYY-MM-DD"),
        values.registrationWindow[1].format("YYYY-MM-DD"),
      ],
    };

    const updatedRoles = roles.map((role) => {
      if (role.id === currentRoleId) {
        if (editingType) {
          // Update existing type
          const updatedTypes = [...role.types];
          updatedTypes[editingTypeIndex] = typeData;
          return {
            ...role,
            types: updatedTypes
          };
        } else {
          // Add new type
          return {
            ...role,
            types: [
              ...role.types,
              typeData
            ],
          };
        }
      }
      return role;
    });

    setRoles(updatedRoles);
    typeForm.resetFields();
    setIsTypeModalOpen(false);
    setEditingType(null);
    setEditingTypeIndex(null);

    showMessage(editingType ? "Type updated successfully" : "Type added successfully");
  };

  const handleProgramFormChange = (field, value) => {
    setProgramFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleThemeChange = (newTheme) => {
    setEventData(prev => ({
      ...prev,
      themeSettings: newTheme
    }));
  };

  const formatDate = (dateStr) => {
    return moment(dateStr).format('MMM DD, YYYY');
  };

  const handleEditType = (type, typeIndex) => {
    setEditingType(type);
    setEditingTypeIndex(typeIndex);
    typeForm.setFieldsValue({
      typeName: type.typeName,
      seatsLimit: type.seatsLimit,
      discount: type.discount,
      registrationWindow: type.registrationWindow ? [
        moment(type.registrationWindow[0]),
        moment(type.registrationWindow[1])
      ] : null,
      payment: type.payment,
      color: type.color,
    });
    setIsTypeModalOpen(true);
  };

  const handleDeleteType = (typeId) => {
    console.log("Deleting type with ID:", typeId);
    Modal.confirm({
      title: "Are you sure you want to delete this type?",
      content: "This action cannot be undone.",
      okText: "Yes, Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        const updatedRoles = roles.map(role => {
          console.log("Checking role:", role);
          if (role.id === currentRoleId) {  // Changed from _id to id
            console.log("Found matching role. Current types:", role.types);
            const filteredTypes = role.types.filter(type => {
              console.log("Comparing type.id:", type.id, "with typeId:", typeId);
              return type.id !== typeId;
            });
            console.log("Filtered types:", filteredTypes);

            return {
              ...role,
              types: filteredTypes
            };
          }
          return role;
        });
        console.log("Updated roles after type deletion:", updatedRoles);

        setRoles(updatedRoles);
        showMessage("Type deleted successfully");
      },
    });
  };;

  // Update handleAddType to handle both add and edit
  const [editingType, setEditingType] = useState(null);
  const [editingTypeIndex, setEditingTypeIndex] = useState(null);

  // const handleAddType = (values) => {
  //   const typeData = {
  //     id: editingType ? editingType.id : Date.now(),
  //     ...values,
  //     registrationWindow: [
  //       values.registrationWindow[0].format("YYYY-MM-DD"),
  //       values.registrationWindow[1].format("YYYY-MM-DD"),
  //     ],
  //   };

  //   const updatedRoles = roles.map((role) => {
  //     if (role.id === currentRoleId) {
  //       if (editingType) {
  //         // Update existing type
  //         const updatedTypes = [...role.types];
  //         updatedTypes[editingTypeIndex] = typeData;
  //         return {
  //           ...role,
  //           types: updatedTypes
  //         };
  //       } else {
  //         // Add new type
  //         return {
  //           ...role,
  //           types: [
  //             ...role.types,
  //             typeData
  //           ],
  //         };
  //       }
  //     }
  //     return role;
  //   });

  //   setRoles(updatedRoles);
  //   typeForm.resetFields();
  //   setIsTypeModalOpen(false);
  //   setEditingType(null);
  //   setEditingTypeIndex(null);

  //   showMessage(editingType ? "Type updated successfully" : "Type added successfully");
  // };


  const roleColumns = [
    { title: "Invitee Name", dataIndex: "roleName", key: "roleName" },
    { title: "Total Seats", dataIndex: "totalSeats", key: "totalSeats" },
    { title: "Per Person Limit", dataIndex: "perPersonLimit", key: "perPersonLimit" },
    {
      title: "Registration",
      key: "registration",
      render: (_, record) =>
        `${record.registrationStart || "-"} → ${record.registrationEnd || "-"}`,
    },
    { title: "Payment", dataIndex: "payment", key: "payment" },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Tooltip title="Edit Role">
            <Button
              type="text"
              icon={<EditOutlined />}
              onClick={() => handleEditRole(record)}
            />
          </Tooltip>
          <Tooltip title="Delete Role">
            <Button
              type="text"
              danger
              icon={<DeleteOutlined />}
              onClick={() => {
                console.log("Delete button clicked, record._id:", record._id);
                handleDeleteRole(record._id); // Make sure this is passing _id
              }}
            />
          </Tooltip>
          <Button
            type="link"
            onClick={() => {
              setCurrentRoleId(record.id);
              setIsTypeModalOpen(true);
            }}
          >
            + Type
          </Button>
        </Space>
      ),
    },
    {
      title: "Invitee Smart Form",
      key: "customForm",
      render: (_, role) => {
        const hasForm = !!customForms[role.id];
        return (
          <div style={{ display: "flex", gap: "8px" }}>
            {!hasForm ? (
              <Button
                type="primary"
                onClick={() => {
                  setCurrentInviteeId(role.id);
                  setIsInviteeModalOpen(true);
                }}
              >
                Design Form
              </Button>
            ) : (
              <Tooltip title="Edit Form">
                <Button
                  type="default"
                  shape="circle"
                  icon={<EditOutlined />}
                  onClick={() => {
                    setCurrentInviteeId(role.id);
                    setCurrentForm(customForms[role.id]);
                    setIsInviteeModalOpen(true);
                  }}
                />
              </Tooltip>
            )}
            {hasForm && (
              <Tooltip title="Preview Form">
                <Button
                  shape="circle"
                  icon={<EyeOutlined />}
                  onClick={() => {
                    setCurrentForm(customForms[role.id]);
                    setIsPreviewModalOpen(true);
                  }}
                />
              </Tooltip>
            )}
          </div>
        );
      }
    },

  ];
  const columns = [
    {
      title: 'Ticket Class',
      dataIndex: 'name',
      key: 'name',
      render: (text) => <div style={{ fontWeight: 500 }}>{text}</div>
    },
    {
      title: 'Template',
      dataIndex: 'templateName',
      key: 'templateName',
      render: (text) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <FileTextOutlined style={{ color: '#999' }} />
          <span>{text}</span>
        </div>
      )
    },
    {
      title: 'Assignment',
      key: 'assignment',
      render: (record) => (
        <div>
          {record.assignmentType === 'role_based' ? (
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4, color: '#666', marginBottom: 8 }}>
                <UserOutlined />
                <span style={{ fontSize: '12px' }}>Role-based</span>
              </div>
              <div>
                {record.roles?.map((role, idx) => (
                  <Tag key={idx} color="purple" style={{ marginBottom: 4 }}>{role}</Tag>
                ))}
              </div>
            </div>
          ) : (
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4, color: '#666', marginBottom: 8 }}>
                <CalendarOutlined />
                <span style={{ fontSize: '12px' }}>Program-based</span>
              </div>
              <div>
                {record.programs?.map((program, idx) => (
                  <Tag key={idx} color="blue" style={{ marginBottom: 4 }}>{program}</Tag>
                ))}
              </div>
            </div>
          )}
        </div>
      )
    },
    {
      title: 'Price',
      dataIndex: 'price',
      key: 'price',
      render: (price) => (
        <span style={{ fontWeight: 500 }}>
          {price === 0 ? 'Free' : `₹${price}`}
        </span>
      )
    },


  ];

  const typeColumns = [
    { title: "Type Name", dataIndex: "typeName", key: "typeName" },
    { title: "Total Seats", dataIndex: "seatsLimit", key: "seatsLimit" },
    { title: "Discount", dataIndex: "discount", key: "discount", render: (d) => `${d || 0}%` },
    {
      title: "Registration",
      dataIndex: "registrationWindow",
      key: "registrationWindow",
      render: (window) => {
        // Add null/undefined check
        if (!window || !Array.isArray(window) || window.length < 2) {
          return "Not set";
        }
        return `${window[0]} → ${window[1]}`;
      },
    },
    { title: "Payment", dataIndex: "payment", key: "payment" },
    {
      title: "Color",
      dataIndex: "color",
      key: "color",
      render: (color) => color ? <Tag color={color}>{color}</Tag> : "No color",
    },
    {
      title: "Actions",
      key: "typeActions",
      render: (_, record, index) => (
        <Space>
          <Tooltip title="Edit Type">
            <Button
              type="text"
              icon={<EditOutlined />}
              onClick={() => handleEditType(record, index)}
            />
          </Tooltip>
          <Tooltip title="Delete Type">
            <Button
              type="text"
              danger
              icon={<DeleteOutlined />}
              onClick={() => handleDeleteType(record)}
            />
          </Tooltip>
        </Space>
      ),
    }
  ];

  const programColumns = [
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      render: (date) => formatDate(date)
    },
    {
      title: 'Time',
      key: 'time',
      render: (record) => `${record.startTime} - ${record.endTime}`
    },
    {
      title: 'Program',
      key: 'program',
      render: (record) => (
        <div>
          <div className="font-medium">{record.title}</div>
          <div className="text-gray-500">{record.description}</div>
        </div>
      )
    },
    {
      title: 'Venue',
      dataIndex: 'venueName',
      key: 'venueName'
    },
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'category',
      render: (category) => <Tag color="blue">{category}</Tag>
    },

    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space>
          <Button
            type="text"
            icon={<Edit size={16} />}
            onClick={() => editProgram(record)}
          />
          <Button
            type="text"
            danger
            icon={<Trash2 size={16} />}
            onClick={() => deleteProgram(record.id)}
          />
        </Space>
      )
    }
  ];

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };


  const steps = [
    { key: "define-event", label: "Define Event", icon: <CalendarOutlined /> },
    { key: "event-program-calendar", label: "Program Calendar", icon: <ClockCircleOutlined /> },
    { key: "registration-categories", label: "Invitee Roles", icon: <TeamOutlined /> },
    { key: "ticketing-setup", label: "Ticketing Setup", icon: <CreditCardOutlined /> },
    { key: "review-and-confirm", label: "Review & Confirm", icon: <FileSearchOutlined /> },
  ];

  const handlePhotoUpload = async (file) => {
    try {
      setUploading(true);

      // create a stable key to persist in DB
      const fileKey = `events/${Date.now()}_${file.name.replace(/\s+/g, "_")}`;

      // upload to S3 (public access)
      await uploadData(fileKey, file, {
        contentType: file.type,
        level: 'public',
      });

      // return the key so backend can persist it
      return fileKey;
    } catch (error) {
      console.error("Upload error:", error);
      message?.error?.('Failed to upload file');
      return null;
    } finally {
      setUploading(false);
    }
  };


  useEffect(() => {
    if (eventData?.poster) {
      fetchPhoto(eventData.poster);
    }
  }, [eventData]);


  const fetchPhoto = async (fileKey) => {
    if (!fileKey) return;
    //console.log("Fetching photo for key:", fileKey);
    try {
      setUploading(true);

      let url;
      // Try object-style call first (compatible with newer @aws-amplify/storage)
      try {
        url = await getUrl({ key: fileKey, level: 'public' });
      } catch (firstErr) {
        console.warn("getUrl(object) failed, trying legacy signature:", firstErr);
        // Fallback to legacy signature (key, options)
        url = await getUrl(fileKey, { level: 'public' });
      }

      console.log("Fetched photo URL:", url);
      // getUrl may return a string or an object depending on version -> normalize
      const resolvedUrl = typeof url === "string" ? url : url?.url || null;
      setPosterUrl(resolvedUrl);
    } catch (error) {
      console.error("Fetch photo error:", error);
    } finally {
      setUploading(false);
    }
  };



  const saveEvent = async (isDraft = false) => {
    try {
      const values = await form.validateFields();
      setUploading(true);

      // Upload files
      const eventPosterKey = eventPoster?.[0] ? await handlePhotoUpload(eventPoster[0]) : null;
      const programPosterKey = programPoster?.[0] ? await handlePhotoUpload(programPoster[0]) : null;
      const termsFileKey = termsFile?.[0] ? await handlePhotoUpload(termsFile[0]) : null;

      const payload = {
        ...values,
        programs,
        inviteeRoles: roles,
        ticketClasses: ticketData,
        form_status: isDraft ? 'draft' : 'saved',
        eventPoster: eventPosterKey,
        programPoster: programPosterKey,
        termsFile: termsFileKey,
        id: draftEventId || null,
      };

      //console.log("Payload to be sent:", payload);
      // return

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/admin/event/addevent`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();
      //console.log("Server Response:", result);

      if (result.success) {
        if (!draftEventId) setDraftEvent(result.data._id);
        const formattedTab = capitalize(activeTab);
        alert(`${formattedTab} saved successfully!`);
        if (isDraft) handleNextTab();
      } else {
        alert(result.message || "Error saving event");
      }

      return result;

    } catch (error) {
      //console.error("Save Event Error:", error);
      alert("Save failed. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  const TicketClasses = () => {


    return (
      <div style={{ padding: '24px 0' }}>
        <Row justify="space-between" align="middle" style={{ marginBottom: 24 }}>
          <Col>
            {/* <h2 style={{ fontSize: '24px', fontWeight: 'bold', margin: 0 }}>Ticket Classes</h2>
            <p style={{ color: '#666', margin: '4px 0 0 0' }}>Configure tickets for your event with templates and roles</p> */}
          </Col>
          <Col>
            {/* <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setShowClassModal(true)}
              size="large"
            >
              Create Ticket Class
            </Button> */}
          </Col>
        </Row>

        <Table
          columns={columns}
          dataSource={ticketData}
          rowKey="id"
          pagination={false}
        />
      </div>
    );
  };
  return (
    <div className="p-6 max-w-7xl mx-auto bg-gray-50 min-h-screen">
      {/* Tab Navigation */}
      <Card style={{ marginBottom: 12 }}>
        <div style={{ display: "flex", borderBottom: "1px solid #f0f0f0" }}>
          {steps.map((step, index) => (
            <Tooltip key={step.key} title={`${step.label}`} placement="top">
              <Button
                type="text"
                onClick={() => setActiveTab(step.key)}
                style={{
                  flex: 1,
                  padding: "16px",
                  display: "flex",
                  alignItems: "center",
                  fontWeight: "bold",
                  fontSize: "16px",
                  justifyContent: "center",
                  gap: "8px",
                  borderBottom: activeTab === step.key ? "3px solid #1677ff" : "3px solid transparent",
                  color: activeTab === step.key ? "#1677ff" : "#595959",
                  fontWeight: activeTab === step.key ? 600 : 500,
                  backgroundColor: activeTab === step.key ? "#f0f5ff" : "transparent",
                  transition: "all 0.3s ease",
                }}
              >
                {step.icon}
                {step.label}
              </Button>
            </Tooltip>
          ))}
        </div>
      </Card>
      {activeTab === "define-event" && (
        <div>
          <Card
            bordered={false}
            className="shadow-sm"
            style={{ borderRadius: 10, padding: 10 }}
          >
            <Form form={form} layout="vertical">

              {/* Event Name, Description & Poster */}
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name="name"
                    label="Event Name"
                    rules={[{ required: true, message: "Please enter event name" }]}
                  >
                    <Input placeholder="Enter Event Name" allowClear />
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    name="description"
                    label="Event Description"
                    rules={[{ required: true, message: "Please enter description" }]}
                  >
                    <Input.TextArea
                      placeholder="Short event description"
                      rows={1}
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="startDate"
                    label="Start Date"
                    rules={[{ required: true, message: "Please select start date" }]}
                  >
                    <DatePicker style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="endDate"
                    label="End Date"
                    rules={[{ required: true, message: "Please select end date" }]}
                  >
                    <DatePicker style={{ width: "100%" }} />
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    name="currency"
                    label="Currency"
                    rules={[{ message: "Please select currency" }]}
                  >
                    <Select placeholder="Select currency">
                      <Option value="INR">INR (₹)</Option>
                      <Option value="USD">USD ($)</Option>
                      <Option value="EUR">EUR (€)</Option>
                      <Option value="GBP">GBP (£)</Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    name="eventType"
                    label="Event Type"
                    initialValue="offline"
                    rules={[{ required: true, message: "Please select event Type" }]}
                  >
                    <Select>
                      <Option value="online">Online</Option>
                      <Option value="offline">Offline</Option>
                      <Option value="both">Both</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={10} align="middle" style={{ marginBottom: 20 }}>
                <Col span={6}>
                  <Form.Item label="Event Poster">
                    <Upload
                      listType="picture-card"
                      beforeUpload={(file) => {
                        setEventPoster([file]);
                        return false; // prevent auto upload
                      }}
                      fileList={eventPoster}
                      accept=".jpg,.jpeg,.png,.gif,.webp"
                      maxCount={1}
                    >
                      {eventPoster.length === 0 && (
                        <div>
                          <PlusOutlined style={{ fontSize: 28, color: "#999" }} />
                          <div style={{ marginTop: 8 }}>Upload</div>
                        </div>
                      )}
                    </Upload>
                  </Form.Item>
                </Col>

                <Col span={4}>
                  <Button
                    icon={<UploadOutlined />}
                    loading={uploading}
                    onClick={() => document.querySelector(".event-poster-upload input").click()}
                    style={{ marginTop: 30 }}
                  >
                    Upload Poster
                  </Button>
                </Col>

                <Col span={8}>
                  <div style={{ fontSize: 12, color: "red", marginTop: 30 }}>
                    Upload a poster with at least <b>600x280px</b> resolution. <br />
                    Allowed formats: <b>jpg, jpeg, png, gif, webp</b> (Max 5 MB)
                  </div>
                </Col>
              </Row>
              <Row gutter={24}>
                {/* Venues Column */}
                <Col span={12}>
                  {venues.map((venue, index) => (
                    <Row gutter={16} key={venue.key} align="middle" style={{ marginBottom: 12 }}>
                      <Col span={7}>
                        <Form.Item
                          name={["venues", index, "venueName"]}
                          label="Venue Name"
                          rules={[{ required: true, message: "Enter venue name" }]}
                        >
                          <Input
                            placeholder="Venue Name"
                            value={venues[index].venueName}
                            onChange={(e) => handleVenueChange(index, "venueName", e.target.value)}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={7}>
                        <Form.Item
                          name={["venues", index, "city"]}
                          label="City"
                          rules={[{ required: true, message: "Enter city" }]}
                        >
                          <Input
                            placeholder="City"
                            value={venues[index].city}
                            onChange={(e) => handleVenueChange(index, "city", e.target.value)}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={7}>
                        <Form.Item
                          name={["venues", index, "state"]}
                          label="State"
                          rules={[{ required: true, message: "Enter state" }]}
                        >
                          <Input
                            placeholder="State"
                            value={venues[index].state}
                            onChange={(e) => handleVenueChange(index, "state", e.target.value)}
                          />

                        </Form.Item>
                      </Col>

                      <Col span={3}>
                        <Button
                          danger
                          type="link"
                          onClick={() => removeVenue(venue.key)}
                          style={{ marginTop: 30 }}
                        >
                          Remove
                        </Button>
                      </Col>
                    </Row>
                  ))}

                  <Button
                    type="dashed"
                    onClick={addVenue}
                    block
                    icon={<PlusOutlined />}
                    style={{ marginBottom: 20 }}
                  >
                    Add Venue
                  </Button>
                </Col>

                {/* Map Column */}
                <Col span={12}>
                  <Form.Item label="Map">
                    <div style={{ maxHeight: "600px", overflowY: "auto" }}>
                      <LocationPicker venues={venues} />
                    </div>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Card>

          {/* Actions */}
          <div
            style={{
              textAlign: "center",
              marginTop: 24,
              marginBottom: 34,
            }}
          >
            <Space>
              <Button
                type="primary"
                size="large"
                onClick={async () => {
                  try {
                    const result = await saveEvent(true); // save current (draft)
                    if (result?.success) {
                      setActiveTab("event-program-calendar"); // move to next tab
                    }
                  } catch (err) {
                    //console.error("Error while saving draft:", err);
                    alert("Failed to save program calendar data.");
                  }
                }}
                // onClick={() => saveEvent(true)}
                style={{
                  borderRadius: 6,
                  padding: "0 14px",
                  fontWeight: 400,
                  background: "linear-gradient(90deg, #1677ff, #4096ff)",
                  boxShadow: "0 4px 12px rgba(22, 119, 255, 0.3)",
                  transition: "all 0.3s ease",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.background =
                    "linear-gradient(90deg, #4096ff, #69b1ff)";
                  e.currentTarget.style.boxShadow =
                    "0 6px 16px rgba(22, 119, 255, 0.45)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.background =
                    "linear-gradient(90deg, #1677ff, #4096ff)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 12px rgba(22, 119, 255, 0.3)";
                }}
              >
                Continue <ArrowRightOutlined size={20} />
              </Button>
            </Space>
          </div>
        </div>

      )}

      {activeTab === "event-program-calendar" && (
        <div>
          <Card
            title={""}
            className="mb-6"
          >
            <div className="flex justify-between items-center mb-4">
              <Button
                type="primary"
                icon={<Plus size={16} />}
                onClick={() => {
                  setProgramFormData(programFormDataDefault);
                  setEditingProgram(null);
                  setProgramModalVisible(true);
                }}
              >
                Add Program
              </Button>
            </div>

            <Table
              columns={programColumns}
              dataSource={programs}
              rowKey="id"
              locale={{
                emptyText: (
                  <div className="text-center py-8">
                    <Calendar className="w-12 h-12 mx-auto mb-3 text-gray-300" />
                    <p>No programs added yet. Click "Add Program" to get started.</p>
                  </div>
                )
              }}
            />
          </Card>

          <div
            style={{
              textAlign: "center",
              marginTop: 24,
              marginBottom: 34,
            }}
          >
            <Space>
              <Button
                type="primary"
                size="large"
                onClick={() => setActiveTab("define-event")}
                style={{
                  borderRadius: 6,
                  padding: "0 14px",
                  fontWeight: 400,
                  background: "linear-gradient(90deg, #1677ff, #4096ff)",
                  boxShadow: "0 4px 12px rgba(22, 119, 255, 0.3)",
                  transition: "all 0.3s ease",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.background =
                    "linear-gradient(90deg, #4096ff, #69b1ff)";
                  e.currentTarget.style.boxShadow =
                    "0 6px 16px rgba(22, 119, 255, 0.45)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.background =
                    "linear-gradient(90deg, #1677ff, #4096ff)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 12px rgba(22, 119, 255, 0.3)";
                }}
              >
                <ArrowLeftOutlined size={20} /> Back
              </Button>
            </Space>

            <Space>
              <Button
                type="primary"
                size="large"
                onClick={async () => {
                  try {
                    const result = await saveEvent(true); // save current (draft)
                    if (result?.success) {
                      setActiveTab("registration-categories"); // move to next tab
                    }
                  } catch (err) {
                    //console.error("Error while saving draft:", err);
                    alert("Failed to save program calendar data.");
                  }
                }}
                style={{
                  borderRadius: 6,
                  padding: "0 14px",
                  fontWeight: 400,
                  marginLeft: 15,
                  background: "linear-gradient(90deg, #1677ff, #4096ff)",
                  boxShadow: "0 4px 12px rgba(22, 119, 255, 0.3)",
                  transition: "all 0.3s ease",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.background =
                    "linear-gradient(90deg, #4096ff, #69b1ff)";
                  e.currentTarget.style.boxShadow =
                    "0 6px 16px rgba(22, 119, 255, 0.45)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.background =
                    "linear-gradient(90deg, #1677ff, #4096ff)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 12px rgba(22, 119, 255, 0.3)";
                }}
              >
                Continue <ArrowRightOutlined size={20} />
              </Button>
            </Space>
          </div>
        </div>
      )}
      {activeTab === "registration-categories" && (
        <div>
          <Card
            title={
              <div className="flex items-center justify-between">
                <span className="flex items-center">Event Invitees</span>
                <Button
                  type="primary"
                  onClick={() => {
                    setCurrentRoleId(null); // Ensure it's a new role
                    roleForm.resetFields();
                    setIsRoleModalOpen(true);
                  }}
                  style={{ marginLeft: 20 }}
                >
                  + Add Invitee
                </Button>
              </div>
            }
            className="mb-6"
          >
            <Table
              dataSource={roles}
              columns={roleColumns}
              rowKey="id"
              expandable={{
                expandedRowRender: (role) => (
                  <>
                    <h4>Types under {role.roleName}</h4>
                    <Table
                      dataSource={role.types}
                      columns={typeColumns}
                      rowKey="id"
                      pagination={false}
                      size="small"
                    />
                  </>
                ),
              }}
              style={{ marginTop: 20 }}
            />

            <div
              style={{
                textAlign: "center",
                marginTop: 24,
                marginBottom: 34,
              }}
            >
              <Space>
                <Button
                  type="primary"
                  size="large"
                  onClick={() => setActiveTab("event-program-calendar")}
                  style={{
                    borderRadius: 6,
                    padding: "0 14px",
                    fontWeight: 400,
                    background: "linear-gradient(90deg, #1677ff, #4096ff)",
                    boxShadow: "0 4px 12px rgba(22, 119, 255, 0.3)",
                    transition: "all 0.3s ease",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.background =
                      "linear-gradient(90deg, #4096ff, #69b1ff)";
                    e.currentTarget.style.boxShadow =
                      "0 6px 16px rgba(22, 119, 255, 0.45)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.background =
                      "linear-gradient(90deg, #1677ff, #4096ff)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 12px rgba(22, 119, 255, 0.3)";
                  }}
                >
                  <ArrowLeftOutlined size={20} /> Back
                </Button>
              </Space>

              <Space>
                <Button
                  type="primary"
                  size="large"
                  onClick={async () => {
                    try {
                      const result = await saveEvent(true); // save current (draft)
                      if (result?.success) {
                        setActiveTab("ticketing-setup");
                        alert("Registration categories saved successfully!");
                      }
                    } catch (err) {
                      //console.error("Error while saving draft:", err);
                      // alert("Failed to save program calendar data.");
                    }
                  }}
                  style={{
                    borderRadius: 6,
                    padding: "0 14px",
                    fontWeight: 400,
                    marginLeft: 15,
                    background: "linear-gradient(90deg, #1677ff, #4096ff)",
                    boxShadow: "0 4px 12px rgba(22, 119, 255, 0.3)",
                    transition: "all 0.3s ease",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.background =
                      "linear-gradient(90deg, #4096ff, #69b1ff)";
                    e.currentTarget.style.boxShadow =
                      "0 6px 16px rgba(22, 119, 255, 0.45)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.background =
                      "linear-gradient(90deg, #1677ff, #4096ff)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 12px rgba(22, 119, 255, 0.3)";
                  }}
                >
                  Continue <ArrowRightOutlined size={20} />
                </Button>
              </Space>
            </div>

          </Card>

          <Modal
            title={currentRoleId ? "Edit Invitee Role" : "Add Invitee Role"}
            open={isRoleModalOpen}
            onCancel={() => {
              setIsRoleModalOpen(false);
              setCurrentRoleId(null);
              roleForm.resetFields();
            }}
            footer={null}
          >
            <Form form={roleForm} onFinish={handleAddRole} layout="vertical">
              <Form.Item
                name="roleName"
                label="Role Name"
                rules={[{ required: true, message: "Please enter role name" }]}
              >
                <Input placeholder="e.g., Visitor, Participant, Sponsor" />
              </Form.Item>

              <Form.Item name="totalSeats" label="Total Seats">
                <InputNumber style={{ width: "100%" }} min={0} />
              </Form.Item>

              <Form.Item name="perPersonLimit" label="Per Person Limit">
                <InputNumber style={{ width: "100%" }} min={1} />
              </Form.Item>

              <Form.Item name="registrationStart" label="Registration Start">
                <DatePicker showTime style={{ width: "100%" }} />
              </Form.Item>

              <Form.Item name="registrationEnd" label="Registration End">
                <DatePicker showTime style={{ width: "100%" }} />
              </Form.Item>

              <Form.Item
                name="payment"
                label="Payment Type"
                rules={[{ required: true }]}
              >
                <Select>
                  <Option value="Free">Free</Option>
                  <Option value="Paid">Paid</Option>
                  <Option value="Free with Approval">Free with Approval</Option>
                </Select>
              </Form.Item>

              <Form.Item>
                <Space>
                  <Button onClick={() => {
                    setIsRoleModalOpen(false);
                    setCurrentRoleId(null);
                    roleForm.resetFields();
                  }}>
                    Cancel
                  </Button>
                  <Button type="primary" htmlType="submit">
                    {currentRoleId ? "Update Role" : "Add Role"}
                  </Button>
                </Space>
              </Form.Item>
            </Form>
          </Modal>

          <Modal
            title={editingType ? "Edit Invitee Type" : "Add Invitee Type"}
            open={isTypeModalOpen}
            onCancel={() => {
              setIsTypeModalOpen(false);
              setEditingType(null);
              setEditingTypeIndex(null);
              typeForm.resetFields();
            }}
            footer={null}
          >
            <Form form={typeForm} onFinish={handleAddType} layout="vertical">
              <Form.Item
                name="typeName"
                label="Type Name"
                rules={[{ required: true, message: "Please enter type name" }]}
              >
                <Input placeholder="VIP, Student, Gold Sponsor, etc." />
              </Form.Item>
              <Form.Item name="seatsLimit" label="Seats Limit">
                <InputNumber style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item name="discount" label="Discount (%)">
                <InputNumber style={{ width: "100%" }} min={0} max={100} />
              </Form.Item>
              <Form.Item
                name="registrationWindow"
                label="Registration Window"
                rules={[{ required: true, message: "Please select registration window" }]}
              >
                <RangePicker style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item
                name="payment"
                label="Payment Config"
                rules={[{ required: true, message: "Please select payment type" }]}
              >
                <Select>
                  <Option value="Free">Free</Option>
                  <Option value="Paid">Paid</Option>
                  <Option value="Free with Approval">Free with Approval</Option>
                </Select>
              </Form.Item>
              <Form.Item name="color" label="Color">
                <Select>
                  <Option value="red">Red</Option>
                  <Option value="blue">Blue</Option>
                  <Option value="green">Green</Option>
                  <Option value="orange">Orange</Option>
                  <Option value="purple">Purple</Option>
                  <Option value="cyan">Cyan</Option>
                </Select>
              </Form.Item>
              <Form.Item>
                <Space>
                  <Button onClick={() => {
                    setIsTypeModalOpen(false);
                    setEditingType(null);
                    setEditingTypeIndex(null);
                    typeForm.resetFields();
                  }}>
                    Cancel
                  </Button>
                  <Button type="primary" htmlType="submit">
                    {editingType ? "Update Type" : "Save Type"}
                  </Button>
                </Space>
              </Form.Item>
            </Form>
          </Modal>



          <Modal
            title={
              <div
                style={{
                  background: "#708090",
                  color: "#fff",
                  padding: "8px 20px",
                  fontSize: "23px",
                  fontWeight: 600,
                  borderRadius: "6px 6px 0 0",
                }}
              >
                Smart Form Designer
              </div>
            }
            open={isInviteeModalOpen}
            onCancel={handleCloseModal}
            footer={null}
            width={1200}

            overflowX="auto"
            centered
            bodyStyle={{ padding: 0 }}
          >
            <div className="p-8">
              <DragDropContext onDragEnd={onDragEnd}>
                <Row gutter={16}>
                  {/* Left Panel */}
                  <Col span={10}>
                    <Card
                      title="Form Settings"
                      size="small"
                      bordered={true}
                    >

                      <Form layout="vertical">
                        <Form.Item label="Form Title">
                          <Input
                            placeholder="Form Title"
                            value={currentForm.title}
                            onChange={(e) =>
                              setCurrentForm({ ...currentForm, title: e.target.value })
                            }
                          />
                        </Form.Item>
                        <Form.Item label="Form Description">
                          <Input.TextArea
                            placeholder="Form Description (optional)"
                            value={currentForm.description}
                            onChange={(e) =>
                              setCurrentForm({
                                ...currentForm,
                                description: e.target.value,
                              })
                            }
                            rows={2}
                          />
                        </Form.Item>
                      </Form>
                      <div
                        style={{
                          flex: 1,
                          overflowY: "auto",
                          marginTop: 12,
                        }}
                      >
                        <FieldPalette />
                      </div>
                      <Divider />
                    </Card>
                  </Col>

                  {/* Middle Panel - Form Builder */}
                  <Col span={14}>

                    <div style={{ width: "100%", padding: 16, borderRight: "1px solid #f0f0f0", overflow: "auto" }}>
                      <Card
                        size="small"
                        bordered={false}
                        style={{ background: "#fafafa", height: "100%", borderRadius: 8 }}
                        bodyStyle={{ padding: 16, height: "100%" }}
                        title={
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <span style={{ fontWeight: 600 }}>Form Fields</span>
                            <Text type="secondary" style={{ fontSize: 12 }}>
                              {currentForm.fields.length} field{currentForm.fields.length !== 1 ? "s" : ""}
                            </Text>
                          </div>
                        }
                      >

                        <Droppable droppableId="form">
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.droppableProps}
                              style={{
                                minHeight: 260,
                                padding: 12,
                                borderRadius: 10,
                                border: snapshot.isDraggingOver ? "2px dashed #40a9ff" : "1px dashed #d9d9d9",
                                background: snapshot.isDraggingOver ? "#f0f9ff" : "#fff",
                                transition: "all 0.25s ease-in-out",
                              }}
                            >
                              {currentForm.fields.length > 0 ? (
                                currentForm.fields.map((field, index) => (
                                  <Draggable key={field.id} draggableId={field.id} index={index}>
                                    {(provided, snapshot) => (
                                      <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={{
                                          ...provided.draggableProps.style,
                                          marginBottom: 12,
                                          padding: "16px 20px",
                                          borderRadius: 8,
                                          border: snapshot.isDragging
                                            ? "2px solid #40a9ff"
                                            : "1px solid #e5e5e5",
                                          background: "#fff",
                                          boxShadow: snapshot.isDragging
                                            ? "0 4px 12px rgba(0,0,0,0.12)"
                                            : "0 2px 6px rgba(0,0,0,0.06)",
                                          transition: "all 0.2s ease",
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                        }}
                                      >
                                        {/* Field Info */}
                                        <div>
                                          <p style={{ fontWeight: 600, margin: 0 }}>{field.label}</p>
                                          <Text type="secondary" style={{ fontSize: 12 }}>
                                            {field.placeholder || "No placeholder"}
                                          </Text>
                                        </div>

                                        {/* Actions */}
                                        <div>
                                          <Button
                                            type="text"
                                            size="small"
                                            icon={<EditOutlined />}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setEditingField(field);
                                              setIsFieldModalOpen(true);
                                            }}
                                          />
                                          <Button
                                            type="text"
                                            size="small"
                                            icon={<CopyOutlined />}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleDuplicateField(field.id);
                                            }}
                                          />
                                          <Button
                                            type="text"
                                            danger
                                            size="small"
                                            icon={<DeleteOutlined />}
                                            onClick={() => handleDeleteField(field.id)}
                                          />
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                ))
                              ) : (
                                <div style={{ textAlign: "center", padding: "50px 12px" }}>
                                  <InboxOutlined style={{ fontSize: 42, color: "#bbb", marginBottom: 8 }} />
                                  <p style={{ fontWeight: 500, marginBottom: 4 }}>Drop fields here</p>
                                  <Text type="secondary">Drag field types from the left to build your form</Text>
                                  {snapshot.isDraggingOver && (
                                    <p style={{ color: "#1890ff", marginTop: 10, fontWeight: 500 }}>
                                      Release to add field
                                    </p>
                                  )}
                                </div>
                              )}
                              {provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </Card>
                    </div>
                  </Col>
                </Row>
              </DragDropContext>

              <Divider />

              <div style={{ textAlign: "right" }}>
                <Button onClick={handleCloseModal} style={{ marginRight: 8 }}>
                  Cancel
                </Button>
                <Button
                  icon={<EyeOutlined />}
                  onClick={() => setIsPreviewModalOpen(true)}
                  style={{ marginRight: 8 }}
                >
                  Preview
                </Button>
                <Button
                  type="primary"
                  icon={<SaveOutlined />}
                  onClick={() => handleSaveForm()}
                >
                  Save Form
                </Button>

              </div>
            </div>
          </Modal>

          <Modal
            visible={isFieldModalOpen}
            onCancel={() => { setIsFieldModalOpen(false); setEditingField(null); }}
            footer={null}
            width={800}
            centered
          >
            <div>
              <h2 style={{ marginBottom: 16 }}>
                {editingField ? "Edit Field" : "Add New Field"}
              </h2>
              <FieldForm
                field={editingField}
                onSave={handleSaveField}
                onCancel={() => { setIsFieldModalOpen(false); setEditingField(null); }}
              />
            </div>
          </Modal>

          {/* Preview Modal */}
          <Modal
            title={null}
            open={isPreviewModalOpen}
            onCancel={() => setIsPreviewModalOpen(false)}
            footer={null}
            width={800}
            centered
            bodyStyle={{ padding: 0 }}
          >
            <div className="bg-white rounded-lg shadow-xl w-full max-w-5xl max-h-full overflow-hidden flex flex-col">
              {/* Header */}
              <h2 className="text-lg font-semibold flex items-center gap-2">
                Form Preview
              </h2>
              {/* Device View Buttons */}
              <Button.Group>
                <Tooltip title="Desktop">
                  <Button
                    type={previewMode === "desktop" ? "primary" : "default"}
                    icon={<DesktopOutlined />}
                    onClick={() => setPreviewMode("desktop")}
                  />
                </Tooltip>
                <Tooltip title="Tablet">
                  <Button
                    type={previewMode === "tablet" ? "primary" : "default"}
                    icon={<TabletOutlined />}
                    onClick={() => setPreviewMode("tablet")}
                  />
                </Tooltip>
                <Tooltip title="Mobile">
                  <Button
                    type={previewMode === "mobile" ? "primary" : "default"}
                    icon={<MobileOutlined />}
                    onClick={() => setPreviewMode("mobile")}
                  />
                </Tooltip>
              </Button.Group>



              {/* Preview Body */}
              <div
                style={{
                  width: previewMode === "desktop" ? "100%" :
                    previewMode === "tablet" ? "768px" : "375px",
                  padding: previewMode === "desktop" ? "32px" :
                    previewMode === "tablet" ? "24px" : "16px"
                }}
                className="bg-white shadow-lg border rounded-lg transition-all duration-300"
              >
                <FormPreview form={currentForm} />
              </div>
            </div>

            {/* Footer */}
            <div className="flex justify-end px-6 py-4 border-t ">
              <Button onClick={() => setIsPreviewModalOpen(false)}>Close</Button>
            </div>

          </Modal>


          {/* Add Type Modal */}
          <Modal
            title="Add Invitee Type"
            open={isTypeModalOpen}

            onCancel={() => setIsTypeModalOpen(false)}
            footer={null}
          >
            <Form form={typeForm} onFinish={handleAddType} layout="vertical">
              <Form.Item name="typeName" label="Type Name" rules={[{ required: true }]}>
                <Input placeholder="VIP, Student, Gold Sponsor, etc." />
              </Form.Item>
              <Form.Item name="seatsLimit" label="Seats Limit">
                <InputNumber style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item name="discount" label="Discount (%)">
                <InputNumber style={{ width: "100%" }} min={0} max={100} />
              </Form.Item>
              <Form.Item name="registrationWindow" label="Registration Window" rules={[{ required: true }]}>
                <RangePicker />
              </Form.Item>
              <Form.Item name="payment" label="Payment Config" rules={[{ required: true }]}>
                <Select>
                  <Option value="Free">Free</Option>
                  <Option value="Paid">Paid</Option>
                  <Option value="Free with Approval">Free with Approval</Option>
                </Select>
              </Form.Item>
              <Form.Item name="color" label="Color">
                <Select>
                  <Option value="red">Red</Option>
                  <Option value="blue">Blue</Option>
                  <Option value="green">Green</Option>
                  <Option value="orange">Orange</Option>
                </Select>
              </Form.Item>
              <Form.Item>
                <Space>
                  <Button onClick={() => setIsTypeModalOpen(false)}>Cancel</Button>
                  <Button type="primary" htmlType="submit">Save Type</Button>
                </Space>
              </Form.Item>
            </Form>
          </Modal>
        </div>
      )}
      {activeTab === "ticketing-setup" && (
        <>
          <TicketManagementUI
            onTicketDataChange={(ticketData) => setTicketData(ticketData)}
            initialTicketClasses={ticketData}
          />
          {/* <BadgeTemplatesGallery /> */}
          <div
            style={{
              textAlign: "center",
              marginTop: 2,
              marginBottom: 34,
            }}
          >
            <Space size="large">
              {/* Back Button */}
              <Button
                size="large"
                onClick={() => setActiveTab("registration-categories")}
                style={{
                  borderRadius: 6,
                  padding: "0 32px",
                  fontWeight: 500,
                }}
              >
                <ArrowLeftOutlined /> Back
              </Button>

              {/* Continue Button */}
              <Button
                type="primary"
                size="large"
                onClick={async () => {
                  // Validate ticket data exists
                  if (!ticketData || ticketData.length === 0) {
                    alert("Please create at least one ticket class before continuing");
                    return;
                  }

                  try {
                    const result = await saveEvent(true); // Save ticketing setup
                    if (result?.success) {
                      alert("Ticketing setup saved successfully!");
                      setActiveTab("review-and-confirm"); // Change to your next tab (e.g., "payment-settings" or "review")
                    }
                  } catch (err) {
                    console.error("Error while saving ticketing setup:", err);
                    alert("Failed to save ticketing setup. Please try again.");
                  }
                }}
                style={{
                  borderRadius: 6,
                  padding: "0 32px",
                  fontWeight: 500,
                  background: "linear-gradient(90deg, #1677ff, #4096ff)",
                  boxShadow: "0 4px 12px rgba(22, 119, 255, 0.3)",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background =
                    "linear-gradient(90deg, #4096ff, #69b1ff)";
                  e.currentTarget.style.boxShadow =
                    "0 6px 16px rgba(22, 119, 255, 0.45)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background =
                    "linear-gradient(90deg, #1677ff, #4096ff)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 12px rgba(22, 119, 255, 0.3)";
                }}
              >
                Continue <ArrowRightOutlined />
              </Button>
            </Space>
          </div>
        </>
      )}
      {activeTab === "review-and-confirm" && (
        <div style={{ padding: 5 }}>
          <Card
            title={
              <span style={{ fontWeight: 600 }}>
                <CalendarOutlined /> Event Details
              </span>
            }
            bordered={false}
            style={{
              marginBottom: 24,
              borderRadius: 12,
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            }}
          >
            <Row gutter={[16, 16]}>
              {/* Left side – Event Details */}
              <Col xs={24} md={16}>
                <Row gutter={[16, 16]}>
                  <Col span={8}><strong>Name:</strong> {eventData?.name || "-"}</Col>
                  <Col span={8}><strong>Currency:</strong> {eventData?.currency || "-"}</Col>
                  <Col span={8}>
                    <strong>Venue:</strong>{" "}
                    {eventData?.venues?.length > 0
                      ? `${eventData.venues[0].venueName}, ${eventData.venues[0].city}, ${eventData.venues[0].state}`
                      : "-"}
                  </Col>

                  <Col span={8}>
                    <strong>Start Date:</strong>{" "}
                    {eventData?.startDate
                      ? new Date(eventData.startDate).toLocaleString()
                      : "-"}
                  </Col>
                  <Col span={8}>
                    <strong>End Date:</strong>{" "}
                    {eventData?.endDate
                      ? new Date(eventData.endDate).toLocaleString()
                      : "-"}
                  </Col>
                  <Col span={8}><strong>Event Type:</strong> {eventData?.eventType || "-"}</Col>

                  <Col span={24}><strong>Description:</strong> {eventData?.description || "-"}</Col>
                </Row>
              </Col>

              {/* Right side – Poster Image */}
              <Col xs={24} md={8} style={{ textAlign: "center" }}>
                {uploading ? (
                  <div
                    style={{
                      width: "100%",
                      height: 200,
                      background: "#fafafa",
                      borderRadius: 12,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#999",
                    }}
                  >
                    Loading poster...
                  </div>
                ) : posterUrl ? (
                  <img
                    src={posterUrl}
                    alt="Event Poster"
                    style={{
                      width: "100%",
                      maxHeight: 250,
                      objectFit: "cover",
                      borderRadius: 12,
                      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                    }}
                  />
                ) : (
                  <div
                    style={{
                      width: "100%",
                      height: 200,
                      background: "#f5f5f5",
                      borderRadius: 12,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#999",
                    }}
                  >
                    No Poster Uploaded
                  </div>
                )}
              </Col>
            </Row>


          </Card>


          {/* Programs */}
          <Card
            title={<span style={{ fontWeight: 600 }}><CarryOutOutlined /> Programs</span>}
            bordered={false}
            style={{ marginBottom: 24, borderRadius: 12, boxShadow: "0 4px 12px rgba(0,0,0,0.08)" }}
          >
            <Table
              dataSource={programs}
              columns={[
                { title: "Title", dataIndex: "title" },
                { title: "Category", dataIndex: "category" },
                { title: "Venue", dataIndex: "venueName" },
                { title: "Date", dataIndex: "date" },
                { title: "Start Time", dataIndex: "startTime" },
                { title: "End Time", dataIndex: "endTime" },
              ]}
              pagination={false}
              rowKey="id"
              bordered
              size="middle"
            />
          </Card>

          {/* Invitee Roles */}
          <Card
            title={<span style={{ fontWeight: 600 }}><UsergroupAddOutlined /> Invitee Roles</span>}
            bordered={false}
            style={{ marginBottom: 24, borderRadius: 12, boxShadow: "0 4px 12px rgba(0,0,0,0.08)" }}
          >
            <Table
              dataSource={roles}
              columns={[
                { title: "Role", dataIndex: "roleName" },
                { title: "Seats", dataIndex: "totalSeats" },
                { title: "Limit/Person", dataIndex: "perPersonLimit" },
                { title: "Payment", dataIndex: "payment" },
                {
                  title: "Registration Window",
                  render: (_, record) => (
                    <span>
                      {record.registrationStart} → {record.registrationEnd}
                    </span>
                  ),
                },
              ]}
              expandable={{
                expandedRowRender: (role) => (
                  <Table
                    dataSource={role.types}
                    columns={[
                      { title: "Type", dataIndex: "typeName" },
                      { title: "Seats Limit", dataIndex: "seatsLimit" },
                      { title: "Discount", dataIndex: "discount", render: (d) => `${d}%` },
                      { title: "Payment", dataIndex: "payment" },
                    ]}
                    pagination={false}
                    rowKey="id"
                    size="small"
                    bordered
                  />
                ),
              }}
              rowKey="id"
              pagination={false}
              bordered
              size="middle"
            />
          </Card>

          <Card
            title={<span style={{ fontWeight: 600 }}><CreditCardOutlined /> Ticketing Setup</span>}
            bordered={false}
            style={{ marginBottom: 24, borderRadius: 12, boxShadow: "0 4px 12px rgba(0,0,0,0.08)" }}
          >


            <Table
              columns={columns}
              dataSource={ticketData}
              rowKey="id"
              pagination={false}
            />
          </Card>
          <Card
            title="Website Publishing"
            style={{ marginBottom: 24 }}
          >
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <p>Publish this event to make it live on your website.</p>
              <Button
                type="primary"
                size="large"
                onClick={async () => {
                  try {
                    const response = await fetch(
                      `${process.env.REACT_APP_API_URL}/api/admin/event/website/publish_event/${draftEventId}`,
                      { method: 'POST' }
                    );
                    const result = await response.json();
                    if (result.success) {
                      alert('Event published successfully!');
                    }
                  } catch (error) {
                    alert('Publish failed');
                  }
                }}
              >
                Publish Event Website
              </Button>

              {eventData?.website?.isPublished && (
                <div style={{ marginTop: 16 }}>
                  <Text type="success">✓ Published</Text>
                  <div style={{ marginTop: 8 }}>
                    <a
                      href={`/event/${draftEventId}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View Live Website
                    </a>
                  </div>
                </div>
              )}
            </div>

          </Card>
          {/* Action Buttons */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "20px", // space between buttons
              marginTop: 20,
            }}
          >
            <Button
              size="large"
              icon={<ArrowLeftOutlined />}
              onClick={() => setActiveTab("registration-categories")}
              style={{
                borderRadius: 6,
                fontWeight: 500,
                padding: "0 24px",
              }}
            >
              Back
            </Button>
            <Button
              type="primary"
              size="large"
              icon={<CheckOutlined />}
              onClick={async () => {
                const result = await saveEvent(false); // final publish
                if (result?.success) {
                  alert("Event Saved successfully!");
                }
              }}
              style={{
                borderRadius: 6,
                padding: "0 24px",
                fontWeight: 500,
                background: "linear-gradient(90deg, #1677ff, #4096ff)",
                boxShadow: "0 4px 12px rgba(22, 119, 255, 0.3)",
              }}
            >
              Save
            </Button>
          </div>

          <ThemeCustomizer
            eventId={draftEventId} // New event, no ID yet
            onThemeChange={handleThemeChange}
          />


        </div>
      )}
      <Modal
        title={`Advanced Settings: ${editingRowKey || ""}`}
        open={openAdvanced}
        onCancel={() => setOpenAdvanced(false)}
        footer={[
          <Button key="cancel" onClick={() => setOpenAdvanced(false)}>
            Cancel
          </Button>,
          <Button key="save" type="primary" onClick={() => setOpenAdvanced(false)}>
            Save
          </Button>,
        ]}
      >
        <Space direction="vertical" style={{ width: '100%' }} size="large">
          <Checkbox>Allow Waitlist</Checkbox>
          <Checkbox>Require Approval</Checkbox>
          <div>
            <div>Custom Fields (JSON)</div>
            <TextArea
              rows={4}
              placeholder='e.g. [{"key":"company","label":"Company"}]'
            />
          </div>
        </Space>
      </Modal>

      {/* Program Modal */}
      <Modal
        title={editingProgram ? "Edit Program" : "Add New Program"}
        open={programModalVisible}
        onCancel={() => setProgramModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setProgramModalVisible(false)}>
            Cancel
          </Button>,
          <Button key="save" type="primary" onClick={handleSaveProgram}>
            Save Program
          </Button>,
        ]}
        width={700}
        bodyStyle={{
          maxHeight: "80vh",
          overflowY: "auto",
          overflowX: "hidden",
        }}
        style={{ top: 50 }}
      >
        <Form layout="vertical">
          {/* Category */}
          <Form.Item label="Category *">
            <Select
              value={programFormData.category}
              onChange={(value) => handleProgramFormChange("category", value)}
            >
              <Option value="sports">Sports</Option>
              <Option value="festival">Festival</Option>
              <Option value="concert">Concert</Option>
              <Option value="expo">Expo</Option>
              <Option value="conference">Conference</Option>
              <Option value="business">Business</Option>
            </Select>
          </Form.Item>

          {/* Title */}
          <Form.Item label="Program Title *">
            <Input
              value={programFormData.title}
              onChange={(e) => handleProgramFormChange("title", e.target.value)}
              placeholder="e.g., Opening Keynote, Workshop Title"
            />
          </Form.Item>

          {/* Description */}
          <Form.Item label="Description">
            <ReactQuill
              theme="snow"
              value={programFormData.description}
              onChange={(value) => handleProgramFormChange("description", value)}
              placeholder="Brief description of the program"
              style={{ height: "130px", marginBottom: "40px" }}
            />
          </Form.Item>

          {/* Event Poster Upload */}
          <Form.Item label="Program Poster">
            <Upload
              listType="picture-card"
              beforeUpload={(file) => {
                setProgramPoster([file]);
                return false;
              }}
              fileList={programPoster}
              accept=".jpg,.jpeg,.png,.gif,.webp"
              maxCount={1}
            >
              {programPoster.length === 0 && (
                <div>
                  <PlusOutlined style={{ fontSize: 28, color: "#999" }} />
                  <div style={{ marginTop: 8 }}>Upload</div>
                </div>
              )}
            </Upload>
          </Form.Item>

          {/* Date, Time, Duration */}
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item label="Date *">
                <DatePicker
                  value={programFormData.date ? moment(programFormData.date) : null}
                  onChange={(date) =>
                    handleProgramFormChange(
                      "date",
                      date ? date.format("YYYY-MM-DD") : ""
                    )
                  }
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Start Time *">
                <TimePicker
                  value={
                    programFormData.startTime
                      ? moment(programFormData.startTime, "HH:mm:ss")
                      : null
                  }
                  onChange={(time) =>
                    handleProgramFormChange(
                      "startTime",
                      time ? time.format("HH:mm:ss") : ""
                    )
                  }
                  style={{ width: "100%" }}
                  format="HH:mm:ss"
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="End Time *">
                <TimePicker
                  value={
                    programFormData.endTime
                      ? moment(programFormData.endTime, "HH:mm:ss")
                      : null
                  }
                  onChange={(time) =>
                    handleProgramFormChange(
                      "endTime",
                      time ? time.format("HH:mm:ss") : ""
                    )
                  }
                  style={{ width: "100%" }}
                  format="HH:mm:ss"
                />
              </Form.Item>
            </Col>
          </Row>

          {/* Duration */}
          <Form.Item label="Duration (Hours:Minutes:Seconds)">
            <TimePicker
              value={
                programFormData.duration
                  ? moment(programFormData.duration, "HH:mm:ss")
                  : null
              }
              onChange={(time) =>
                handleProgramFormChange(
                  "duration",
                  time ? time.format("HH:mm:ss") : ""
                )
              }
              style={{ width: "100%" }}
              format="HH:mm:ss"
            />
          </Form.Item>

          {/* Venue */}
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item label="Venue Name">
                <Input
                  value={programFormData.venueName}
                  onChange={(e) => handleProgramFormChange("venueName", e.target.value)}
                  placeholder="Venue name"
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="City">
                <Input
                  value={programFormData.city}
                  onChange={(e) => handleProgramFormChange("city", e.target.value)}
                  placeholder="City"
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="State">
                <Input
                  value={programFormData.state}
                  onChange={(e) => handleProgramFormChange("state", e.target.value)}
                  placeholder="State"
                />
              </Form.Item>
            </Col>
          </Row>
          <Col span={12}>
            <Form.Item label="Map Preview">
              <div style={{ width: "100%", height: 300, borderRadius: 8, overflow: "hidden" }}>
                {programFormData.venueName || programFormData.city || programFormData.state ? (
                  <iframe
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    style={{ border: 0 }}
                    src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyB-gVctQM60ryDKyVillfLrYrG0DXIvQuA&q=${encodeURIComponent(
                      `${programFormData.venueName || ""}, ${programFormData.city || ""}, ${programFormData.state || ""}`
                    )}`}
                    allowFullScreen
                  ></iframe>
                ) : (
                  <div
                    style={{
                      textAlign: "center",
                      lineHeight: "300px",
                      color: "#999",
                      background: "#f8f8f8",
                      borderRadius: 8,
                    }}
                  >
                    Enter Venue Name, City, or State to view map
                  </div>
                )}
              </div>
            </Form.Item>
          </Col>
          <Form.Item label="Terms & Conditions File">
            <Upload
              beforeUpload={(file) => {
                setTermsFile([file]);
                return false;
              }}
              fileList={termsFile}
              accept=".pdf,.jpg,.jpeg,.png"
              maxCount={1}
            >
              <Button icon={<UploadOutlined />}>Select File</Button>
            </Upload>
          </Form.Item>

          {/* Support Contact */}
          <Form.Item label="Support Contact Details">
            <Input
              value={programFormData.supportContact}
              onChange={(e) =>
                handleProgramFormChange("supportContact", e.target.value)
              }
              placeholder="Phone number or email for support"
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}


